import React from 'react'

import Main from './components/Main'
import './App.css'

export default function App() {
  return (
    <div>
      <Main />
      <footer>Feito com ❤️ por Gabriel Sales</footer>
    </div>
  )
}
